import { z } from 'zod';
import { ZodZoneConfiguration } from '../Zone/types';

export const ZodDisplayConfiguration = z.object({
    id: z.number().nullish(),
    name: z.string().nullish(),
    type: z.string().nullish(),

    scope: z.string().nullish(),
    debug: z.union([z.number(), z.string(), z.boolean()]).nullish(),

    width: z.number().nullish(),
    height: z.number().nullish(),

    updated: z.number().nullish(),

    zones: z.array(ZodZoneConfiguration).nullish(),
});

export type DisplayConfiguration = z.infer<typeof ZodDisplayConfiguration>;
